import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import type { AxiosError } from 'axios';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import AuthLayout from '@/components/Auth/AuthLayout.vue';
import AuthCardHeader from '@/components/Auth/AuthCardHeader.vue';
import OrDivider from '@/components/Auth/OrDivider.vue';
import SocialAuthButton from '@/components/Auth/SocialAuthButton.vue';
import CButton from '@/components/shared/CButton/CButton.vue';
import CError from '@/components/shared/CError.vue';
import CInput from '@/components/shared/CInput/CInput.vue';
import { externalLogin, passwordLogin } from '@/api/auth';
import { useExternalAuth } from '@/composables/externalAuth';
import { externalAuthErrorMessage, isExpectedAuthError } from '@/utils/authUtils';
import { notifyAngularSignIn } from '@/utils/userUtils';
import { ExternalAuthOutcome, TIKTOK_SIGN_IN_ENABLED, type ExternalProvider } from '@/typings/auth/externalAuth';

// The backend's wording for a wrong username or password

export default /*#__PURE__*/_defineComponent({
  __name: 'SignIn',
  setup(__props) {

const INVALID_CREDENTIALS = 'The email or password you entered is incorrect';

const { authenticate, loadingProvider } = useExternalAuth();

const username = ref('');
const password = ref('');
const signingIn = ref(false);
const errorMessage = ref('');

const signIn = async () => {
    errorMessage.value = '';

    signingIn.value = true;
    try {
        await passwordLogin(username.value.trim(), password.value);
        notifyAngularSignIn();
    } catch (error) {
        // Wrong credentials are expected, anything else is worth a look (same rule as the AngularJS page had)
        if ((error as AxiosError)?.response?.data?.error !== INVALID_CREDENTIALS) {
            window.rumReportError(error as Error);
        }
        errorMessage.value = externalAuthErrorMessage(error, INVALID_CREDENTIALS);
    } finally {
        signingIn.value = false;
    }
};

const signInWith = async (provider: ExternalProvider) => {
    errorMessage.value = '';
    try {
        await authenticate(provider, 'signin', {}, async (result) => {
            if (result.outcome === ExternalAuthOutcome.CheckoutRequired && result.checkoutUrl) {
                // Signed up but never paid: back to the checkout before the app opens
                window.location.assign(result.checkoutUrl);
                return 'navigating';
            }

            if (result.loginTicket) {
                await externalLogin(result.loginTicket);
                notifyAngularSignIn();
            }
        });
    } catch (error) {
        // A closed popup or a code the user can act on is not a failure to report
        if ((error as AxiosError)?.isAxiosError && !isExpectedAuthError(error)) {
            window.rumReportError(error as Error);
        }
        errorMessage.value = externalAuthErrorMessage(error, 'We could not sign you in. Please try again.');
    }
};

return { __sfc: true,INVALID_CREDENTIALS, authenticate, loadingProvider, username, password, signingIn, errorMessage, signIn, signInWith, ValidationObserver, ValidationProvider, AuthLayout, AuthCardHeader, OrDivider, SocialAuthButton, CButton, CError, CInput, TIKTOK_SIGN_IN_ENABLED }
}

})